<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->
        <!-- <config-hang >
          <img slot="config_hang_ele1" src="~assets/img/config/hostname.png" alt />
          <span slot="config_hang_ele2">{{serveHostData.gatewayName}}</span>
        </config-hang>-->
        <!-- <config-title-hang>
          <span slot="config_title_hang_ele2">主机信息</span>
          <img
            slot="config_title_hang_ele5_img"
            src="~assets/img/config/jiebang.png"
            alt
            @click="jieBangHostBtnHandle"
            v-if="serveHostData.userId != '' "
          />
          <span
            slot="config_title_hang_ele5"
            @click="jieBangHostBtnHandle"
            v-if="serveHostData.userId != '' "
          >解绑主机</span>
        </config-title-hang>-->

        <config-input-row>
          <img slot="config_hang_input_img"
               src="~assets/img/config/weiyima.png"
               alt />
          <input slot="config_hang_input_left"
                 type="text"
                 v-model="serveHostData.uniqueCode16"
                 placeholder="请输入新主机唯一码" />
        </config-input-row>
        <!-- //代号20220220-6 -->
        <div class="xiaotishi_style">小提示：绑定新主机，请先保证主机已经连接到网络，并上线。（主机的状态灯常亮，即表示主机已上线）~</div>
        <!-- 统一点击按钮 //代号20220220-6-->
        <div class="public_config_que_ren_btn"
             @click="saveReturnBtnHandle">绑定</div>
      </div>
    </div>
  </div>
</template>
<script>
import ConfigInputRow from '@/components/common/config/config-input-row';
// import topNav from "components/common/topnav/topnav";
// import topNavItem from "components/common/topnav/topnavitem";
import configTitleHang from "components/common/config/config-title-hang";

import configHang from "components/common/config/config-hang";
export default {
  data () {
    return {
      serveHostData: {
        ////服务器请求到的主机数据
        deleteState: 0,
        dropTime: "",
        extranetIp: "",
        gateway: "",
        gatewayId: "",
        gatewayName: "",
        intranetIp: "",
        mac: "",
        port: "",
        subnetMask: "",
        uniqueCode: "",
        uniqueCode16: "",
        userId: "",
        version: ""
      }
    };
  },
  components: {
    ConfigInputRow,
    // topNav,
    // topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    jieBangHostBtnHandle () {
      ///解绑主机按钮被点击了
      /// 解绑网关接口
      // console.log(this.$route.query)
      this.$showTipsToast(9, this.serveHostData);
    },
    saveReturnBtnHandle () {
      // console.log(this.$route.query)
      ////处理一下入参
      if (this.serveHostData.uniqueCode16 === "") {
        this.$toast("主机唯一码不能为空！");
        return;
      } else if (this.serveHostData.uniqueCode16.length != 8) {
        this.$toast("请输入8位有效的主机ID！");
        return;
      }

      /// 根据网关唯一码获取网关信息接口，获取数据
      // console.log(this.$route.query);
      this.$request({
        method: "post",
        url: "/gateway/findGatewayByUniqueCode",
        data: {
          token: this.$store.state.token,
          uniqueCode16: this.serveHostData.uniqueCode16
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            this.serveHostData = res.data.data; ////拿到服务器返回的数据结果

            /// 绑定网关接口
            this.$request({
              method: "post",
              url: "/gateway/bindGatewayByGatewayId",
              data: {
                token: this.$store.state.token,
                gatewayId: this.serveHostData.gatewayId,
                gatewayName: this.serveHostData.gatewayName
              }
            })
              .then(res => {
                if (res.data.code != 0) {
                  this.$showTipsToast(3, res.data.message);
                  ////说明信息填写错误,控制失败了，
                  return;
                } else {
                  ////、控制成功了
                  // this.serveHostData = res.data.data; ////拿到服务器返回的数据结果
                  this.$showTipsToast(1, "添加成功", true); ////提示框
                  this.$router.go(-1);
                }
              })
              .catch(error => {
                console.log(error);
              });
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });

      ////保存并返回按钮被点击了
    }
  },

  mounted () {
    console.log("mounted阶段");
  },
  created () {
    console.log("created阶段");
  }
};
</script>

<style>
</style>